import { call, put } from 'redux-saga/effects';

import type { CallbackFunction } from '@types';
type ReduxAction = {
  type: string;
  payload?: unknown;
};

type CallbackType = CallbackFunction | ReduxAction | null | undefined;

export function* handleCallbackFunction(callback: CallbackType) {
  if (!callback) {
    return;
  }

  if (typeof callback === 'function') {
    yield call(callback as any);
  } else if (typeof callback === 'object' && callback.type) {
    yield put(callback);
  }
}
